export const countryCodes = {
  CA: 'CA',
  CN: 'CN',
  HK: 'HK',
  JP: 'JP',
  MO: 'MO',
  TW: 'TW',
  US: 'US',
};

export const demographicInputFieldNames = {
  CITY: 'city',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MAILING_ADDRESS: 'mailingAddress',
  PHONE: 'phone',
  REIMBURSEMENT_AMOUNT: 'reimbursementAmount',
  THIRD_PARTY_REPAIR: 'thirdPartyRepair',
  ZIP: 'zip',
};

export const fileValidation = {
  VALID: 'VALID',
  TOO_MANY: 'TOO_MANY',
  TOO_LARGE: 'TOO_LARGE',
};

export const payorInputFieldNames = {
  ACCOUNT_TYPE: 'accountType',
  IBAN: 'iban',
};

export const reimbursementEligibility = {
  ACCEPT: 'ACCEPT',
  REJECT: 'REJECT',
  REVIEW_NEEDED: 'REVIEW_NEEDED',
};

export const rejectReasonCodes = {
  AFTERMARKET: 'aftermarket',
  AFTERMARKET_ELECTIVEUPGRADE: 'aftermarketElectiveUpgrade',
  AGE: 'age',
  AGE_MILEAGE: 'ageMileage',
  AGE_UNSUPPORTED: 'ageUnsupported',
  ELECTIVEUPGRADE: 'electiveUpgrade',
  INELIGIBLE: 'ineligible',
  MILEAGE: 'mileage',
  MILEAGE_AFTERMARKET: 'mileageAftermarket',
  MILEAGE_OUTOFREGION: 'mileageOutOfRegion',
  MILEAGE_UNSUPPORTED: 'mileageUnsupported',
  MILEAGE_UNSUPPORTED_OUTOFREGION: 'mileageUnsupportedOutOfRegion',
  NOREIMBURSABLEREPAIR: 'noReimbursableRepair',
  OUTOFREGION: 'outOfRegion',
  OUTOFREGION_UNSUPPORTED: 'outOfRegionUnsupported',
  POSTNOTICE: 'postNotice',
  UNRELATED: 'unrelated',
  UNSUPPORTED: 'unsupported',
};

export const reimbursementCaseStatus = {
  OPEN: 'OPEN',
};

export const inputLength = {
  MAX_LENGTH: 500,
};

export const CategoryCode = {
  GDPR: 'TCC-SYS-ESC-5',
};

export const flagStatuses = {
  NONE: 'NONE',
  NON_SOLAR: 'NON_SOLAR',
  ALL: 'ALL',
};

export const concernTypes = {
  Solar_Support: 'Solar_Support',
  NA_TeslaSupport: 'NA_TeslaSupport',
};

// source of truth:
// https://confluence.teslamotors.com/pages/viewpage.action?pageId=1008591847
export const oceanaConcernMap = {
  accountBilling: 'SolarAccountBilling',
  addVehicleToTeslaAccount: 'TeslaApp',
  autopilotFullSelfDrivingCapability: 'FSD',
  bluetoothKeyFob: 'BluetoothKeyFob',
  cancelMyOrder: 'TeslaShop',
  chargingRange: 'ChargingRange',
  extendedServiceAgreementWarrantyInformation: 'Warranty',
  homeCharging: 'HomeCharging',
  maintenanceTroubleshooting: 'SolarMainTroubleshooting',
  energyScheduling: 'SolarMainTroubleshooting',
  solarPanelRemoval: 'ERR',
  placeAnOrder: 'TeslaShop',
  powerwallMaintenanceTroubleshooting: 'PWMainTroubleshooting',
  productFitInstallation: 'TeslaShop',
  questionAboutAnUpcomingServiceAppointment: 'UpcomingAppt',
  returnAnItem: 'TeslaShop',
  scheduleModifyOrCancelAServiceAppointment: 'ApptChanges',
  softwareFirmware: 'Firmware',
  supercharging: 'Supercharging',
  teslaApp: 'TeslaApp',
  touchscreen: 'Touchscreen',
  trackMyOrderStatus: 'TeslaShop',
  wallConnector: 'WallConnector',
};

export const issueSubCategories = {
  maintenanceTroubleshooting: 'maintenanceTroubleshooting',
  powerwallMaintenanceTroubleshooting: 'powerwallMaintenanceTroubleshooting',
};

export const oceanaRoutePointMap = {
  [concernTypes.Solar_Support]: {
    LOB: 'Energy',
    RoutePointIdentifier: 'EnergySupport',
  },
  [concernTypes.NA_TeslaSupport]: {
    LOB: 'Vehicle',
    RoutePointIdentifier: 'VehicleSupport',
  },
};

export const COUNTRY_TO_CURRENCY = {
  AD: 'EUR',
  AE: 'AED',
  AT: 'EUR',
  AU: 'AUD',
  BE: 'EUR',
  CA: 'CAD',
  CH: 'CHF',
  CN: 'CNY',
  CZ: 'CZK',
  DE: 'EUR',
  DK: 'DKK',
  EE: 'EUR',
  ES: 'EUR',
  EU: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  GB: 'GBP',
  GR: 'EUR',
  HK: 'HKD',
  HR: 'HRK',
  IE: 'EUR',
  IL: 'ILS',
  IS: 'ISK',
  IT: 'EUR',
  JO: 'JOD',
  JP: 'JPY',
  KR: 'KRW',
  LU: 'EUR',
  MC: 'EUR',
  MO: 'HKD',
  MT: 'EUR',
  MX: 'MXN',
  NL: 'EUR',
  NO: 'NOK',
  NZ: 'NZD',
  PL: 'PLN',
  PR: 'USD',
  PT: 'EUR',
  SE: 'SEK',
  SG: 'SGD',
  SI: 'EUR',
  TW: 'TWD',
  US: 'USD',
  ZA: 'ZAR',
};

export const PAGES = {
  GENERATE_IRA_DOCUMENT_CONFIRMATION: '/ira-document/confirmation',
  GENERATE_IRA_DOCUMENT_TRY_AGAIN: '/ira-document/try-again',
  TROUBLESHOOTING: '/troubleshooting',
  TROUBLESHOOTING_CONFIRMATION: '/troubleshooting/confirmation',
  SUCCESS: '/troubleshooting/success',
  REIMBURSEMENT: '/reimbursement',
  REIMBURSEMENT_CONFIRM: '/reimbursement/confirm',
  PW_REBATE_CONFIRMATION: '/powerwallRebate/confirmation',
  ROOT: '/',
  UPLOAD_DOCUMENTS: '/document-upload',
  UPLOAD_DOCUMENTS_CONFIRMATION: '/document-upload/confirmation',
};

export const TimeInMs = {
  ONE_DAY: 24 * 60 * 60 * 1000,
  ONE_WEEK: 7 * 24 * 60 * 60 * 1000,
  THREE_YEARS: 3 * 365 * 24 * 60 * 60 * 1000,
};

export const FILE_UPLOAD_TYPES = '.pdf,.jpg,.jpeg,.png';

export const MAX_FILE_SIZE = 1024 * 1024 * 10;

export const DESCRIBE_YOUR_QUESTION_LENGTH = 400;

export const TESLA_ASSIST_UNIVERSAL_LINK =
  'https://ownership.tesla.com/##LOCALE##/get-app/contact_us_tesla_assist_chat_screen/contact_us';

export const CONFIRMATION_VARIATIONS = {
  DATA_REQUEST_SENT: 'DATA_REQUEST_SENT',
  EMAIL_SENT: 'EMAIL_SENT',
};

export const CN_HOST_ENVS = {
  APP: 'APP',
  WECHAT: 'Mini',
  WEB: 'Web',
};
